// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb4425f1","455":"538dc3a7","977":"75b113a7"}[chunkId] + ".chunk.js";
};